var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-body"},[_c('div',{staticClass:"no-data"},[_c('div',{staticClass:"dz-no-content-message",attrs:{"dz-preview-wrapper":""}},[_c('h3',[_vm._v("Keine Prozesse vorhanden.")]),_c('img',{staticClass:"no-data default-cursor",attrs:{"src":require("../assets/img/workflow.svg")}})])])])
}]

export { render, staticRenderFns }